import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "close-box"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-close-box',
    templateUrl: './icon-close-box.component.html',
    styleUrls: ['./icon-close-box.component.scss'],
    standalone: false
})
export class IconCloseBoxComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
